import { siteInfo } from '@/mocks/home';

export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>

      <div className="relative w-full px-4 md:px-6 pt-[72px]">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12 py-10 md:py-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-primary-100/80 text-primary-700 text-xs font-semibold rounded-full mb-4">
              <i className="ri-fire-line"></i>
              下拉式漫画阅读
            </span>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-3">
              樱花动漫91 · 海量漫画免费在线看
            </h1>

            <p className="text-sm md:text-base text-foreground-600 mb-6 max-w-[560px] mx-auto lg:mx-0 leading-relaxed">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center lg:text-left">
                  <div className="text-lg md:text-xl font-heading font-bold text-primary-600">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => { e.preventDefault(); handleScroll('#cards'); }}
                className="w-full sm:w-auto px-6 py-3 text-sm font-semibold text-background-50 bg-primary-500 rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                立即开始阅读
              </a>
              <a
                href="#features"
                onClick={(e) => { e.preventDefault(); handleScroll('#features'); }}
                className="w-full sm:w-auto px-6 py-3 text-sm font-semibold text-foreground-700 border border-background-300 rounded-lg hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                了解平台特色
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20vibrant%20anime%20illustration%20of%20a%20cozy%20reading%20scene%20with%20multiple%20manga%20books%20floating%20in%20a%20magical%20arrangement%2C%20soft%20warm%20lighting%2C%20cherry%20blossom%20petals%20drifting%2C%20comfortable%20atmosphere%2C%20rich%20orange%20and%20peach%20warm%20tones%2C%20detailed%20illustration%20style%2C%20dreamy%20ethereal%20quality%2C%20no%20text&width=1000&height=750&seq=hero-main&orientation=landscape"
                alt="樱花动漫91 - 下拉式漫画阅读平台主视觉"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}